<div class="content">
  <button mat-icon-button class="close-button bg-transparent" mat-dialog-close>
    <mat-icon aria-hidden="false">close</mat-icon>
  </button>
  <div class="text-center mat-dialog-title">Légijárművek</div>
  <mat-tab-group #aircraftTab mat-stretch-tabs>
    <mat-tab label="Új légijármű">
      <form [formGroup]="newAircraft" (ngSubmit)="registration()">
        <div class="flex flex-space-between">
          <label class="col-5">Jeladó azonosítóa</label>
          <div class="col-6 flex flex-space-between">
            <mat-form-field class="w-75" appearance="outline">
              <input matInput type="text" formControlName="deviceId" />
            </mat-form-field>
            <button mat-icon-button type="button" (click)="lookup()" class="search" matTooltip="Keresés és automatikus kitöltés">
              <mat-icon>search</mat-icon>
            </button>
          </div>
        </div>
        <div class="flex flex-space-between">
          <label class="col-5">Jeladó típusa</label>
          <mat-form-field class="col-6" appearance="outline">
            <mat-select formControlName="beaconType">
              <mat-option *ngFor="let type of beaconTypes" [value]="type">{{type}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex flex-space-between">
          <label class="col-5">Légijármű típus</label>
          <mat-form-field class="col-6" appearance="outline">
            <input matInput type="text" formControlName="aircraftType" />
          </mat-form-field>
        </div>
        <div class="flex flex-space-between">
          <label class="col-5">Lajstromjel</label>
          <mat-form-field class="col-6" appearance="outline">
            <input matInput type="text" formControlName="registrationNumber" />
          </mat-form-field>
        </div>
        <div class="flex mt-4">
          <mat-checkbox
            formControlName="owner"
            [ngClass]="!newAircraft.get('owner').valid && newAircraft.get('owner').touched ? 'mat-checkbox-invalid': ''">
            Igazolom, hogy én vagyok a tulajdonos
          </mat-checkbox>
        </div>
        <div class="flex-center mt-4">
          <button mat-flat-button color="primary" type="submit">Regisztrálás</button>
        </div>
      </form>
    </mat-tab>
    <mat-tab label="Légijárműveim">
      <div class="aircrafts" *ngIf="dataSource.data.length > 0; else noAircraft">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="beaconType">
            <th mat-header-cell *matHeaderCellDef>JeladóT.</th>
            <td mat-cell *matCellDef="let aircraft">{{ aircraft.beaconType.toString() }}</td>
          </ng-container>
          <ng-container matColumnDef="deviceId">
            <th mat-header-cell *matHeaderCellDef>JeladóID</th>
            <td mat-cell *matCellDef="let aircraft">{{ aircraft.deviceId }}</td>
          </ng-container>
          <ng-container matColumnDef="aircraftType">
            <th mat-header-cell *matHeaderCellDef>LégijárműT.</th>
            <td mat-cell *matCellDef="let aircraft">{{ aircraft.aircraftType }}</td>
          </ng-container>
          <ng-container matColumnDef="registrationNumber">
            <th mat-header-cell *matHeaderCellDef>Lajstrom</th>
            <td mat-cell *matCellDef="let aircraft">{{ aircraft.registrationNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="remove">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let aircraft">
              <mat-icon class="delete vertical-center" (click)="removeAircraft(aircraft)"
              >delete
              </mat-icon>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
        </table>
      </div>
      <ng-template #noAircraft>
        <div class="flex-center mt-5">Nincsenek felvett járművek.</div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
